import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-81" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-82" data-mp="1ge0jz00mfije">
        <h2 className="text-center font-serif text-[1.75rem] font-black leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-83" data-mp="2e0fxjqpxfw1o">
          Preguntas Frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-84" data-mp="2924rlr2r65oq">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-xl bg-white" data-id="element-85" data-mp="1z3yoj657mtia" data-mpi={index}>
                <h3 data-id="element-86" data-mp="smv44kuokq93">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600/40" data-id="element-87" data-mp="snd49skgroma">
                    <span className="text-sm font-bold text-stone-900" data-id="element-88" data-mp="fjrzt3is2xpk">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-red-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-89" data-mp="fm4gldcsv211" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-90" data-mp="3sywqu9mvuifr">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-91" data-mp="1sd53zfid82o">
                      <p className="whitespace-pre-line px-6 pb-5 text-sm leading-relaxed text-stone-600" data-id="element-92" data-mp="1uifhln2ojwoy">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}